import _ from 'lodash'

class SearchParametersService {
  constructor(SubscriptionService) {
    this.SubscriptionService = SubscriptionService
    this.advanced = {}
    this.quick = {}
    this.entity = {}
  }

  get searchParameterMultiValue() {
    return searchParameterMultiValue
  }

  get defaultQuickCriteria() {
    return defaultQuickCriteria
  }

  get defaultEntityCriteria() {
    return defaultEntityCriteria
  }

  get counties() {
    return counties[this.advanced.state]
  }

  get allCounties() {
    return counties
  }

  get meridians() {
    return meridians[this.advanced.state]
  }

  get allMeridians() {
    return meridians
  }

  get sections() {
    return sections[this.advanced.state]
  }

  get allSections() {
    return sections
  }

  get townships() {
    return townships[this.advanced.state][this.advanced.meridian]
  }

  get allTownships() {
    return townships
  }

  get ranges() {
    return ranges[this.advanced.state][this.advanced.meridian]
  }

  get allRanges() {
    return ranges
  }

  get docTypes() {
    return documentTypes[this.advanced.state]
  }

  get allDocTypes() {
    return documentTypes
  }

  get quickAttributes() {
    return quickAttributes
  }

  get entityAttributes() {
    return entityAttributes
  }

  get entitySearchParams() {
    if (this.entity.attribute) {
      return {
        [this.entity.attribute] : this.entity.value
      }
    }

    return {}
  }

  fromQuick() {
    this.fromQuickLink = true
  }

  get disallowedCriteria() {
    return {
      OK: ['abstract', 'block'],
      TX: ['section', 'township', 'range', 'nineSpot', 'meridian']
    }
  }

  get excludedStates() {
    return ['NM']
  }

  searchableStates() {
    return this.SubscriptionService.searchableStates()
      .then(states => {
        const searchableStates = _.difference(states, this.excludedStates)
        if (searchableStates.length > 1) {
          this.defaultState = 'OK'
          this.states = _.sortBy(searchableStates)
        } else {
          this.defaultState = searchableStates[0]
          this.states = searchableStates
        }
        this.setDefaultCriteria()
      })
  }

  setDefaultCriteria() {
    this.defaultCriteria = {
      state : this.defaultState,
      meridian: 'IM',
      township : '',
      range : '',
      section : null,
      typeOfDocument : 'all'
    }
  }

  get isEmpty() {
    return _.isEmpty(this.advanced)
      && _.isEmpty(this.quick)
      && _.isEmpty(this.entity)
  }

  get queryParams() {
    const params =  _.extend(
      {},
      this.advanced,
      this.entitySearchParams
    )
    return _.omit(params, this.disallowedCriteria[params.state])
  }

  get quickParams() {
    const typeOfDocument = (this.quick.attribute === 'respondent')
      ? 'Respondent'
      : null

    return {
      [this.quick.attribute] : this.quick.value,
      typeOfDocument: typeOfDocument
    }
  }
}

const searchParameterMultiValue = 'Any'

const defaultQuickCriteria = {
  attribute: 'apiNumber',
  value: null
}

const defaultEntityCriteria = {
  attribute: 'entity',
  value: null
}

// Currently (08-14-2015) the human readable values are
// passed as keys to the search service.  This structure positions
// us to support changing the display names (the values in the map below)
// from the keys - either because we want to display "Leases", or
// because the search service changes to take 'permit' as a term
const documentTypes = {
  OK: {
    'all': 'All Documents',
    'Commingle': 'Commingle',
    'Completion': 'Completion',
    'Permit to Drill': 'Permit to Drill',
    'Transfer of Operator' : 'Transfer of Operator',
    'Plugging': 'Plugging',
    'Lease': 'Lease',
    'Location Exception': 'Location Exception',
    'Increased Density': 'Increased Density',
    'Spacing': 'Spacing',
    'Pooling': 'Pooling',
    'Unitization': 'Unitization',
    'Production': 'Production'
  },
  TX: {
    'all': 'All Documents',
    'Completion': 'Completion',
    'Permit to Drill': 'Permit to Drill',
    'Transfer of Operator' : 'Transfer of Operator',
    'Production': 'Production',
    'Plugging': 'Plugging'
  }
}
documentTypes.All = _.merge({}, documentTypes.OK, documentTypes.TX)

const counties = {
  OK: [
        'Adair',
        'Alfalfa',
        'Atoka',
        'Beaver',
        'Beckham',
        'Blaine',
        'Bryan',
        'Caddo',
        'Canadian',
        'Carter',
        'Cherokee',
        'Choctaw',
        'Cimarron',
        'Cleveland',
        'Coal',
        'Comanche',
        'Cotton',
        'Craig',
        'Creek',
        'Custer',
        'Delaware',
        'Dewey',
        'Ellis',
        'Garfield',
        'Garvin',
        'Grady',
        'Grant',
        'Greer',
        'Harmon',
        'Harper',
        'Haskell',
        'Hughes',
        'Jackson',
        'Jefferson',
        'Johnston',
        'Kay',
        'Kingfisher',
        'Kiowa',
        'Latimer',
        'Le Flore',
        'Lincoln',
        'Logan',
        'Love',
        'Major',
        'Marshall',
        'Mayes',
        'McClain',
        'McCurtain',
        'McIntosh',
        'Murray',
        'Muskogee',
        'Noble',
        'Nowata',
        'Okfuskee',
        'Oklahoma',
        'Okmulgee',
        'Osage',
        'Ottawa',
        'Pawnee',
        'Payne',
        'Pittsburg',
        'Pontotoc',
        'Pottawatomie',
        'Pushmataha',
        'Roger Mills',
        'Rogers',
        'Seminole',
        'Sequoyah',
        'Stephens',
        'Texas',
        'Tillman',
        'Tulsa',
        'Wagoner',
        'Washington',
        'Washita',
        'Woods',
        'Woodward'
       ],
  TX: [
        'Anderson',
        'Andrews',
        'Angelina',
        'Aransas',
        'Archer',
        'Armstrong',
        'Atascosa',
        'Austin',
        'Bailey',
        'Bandera',
        'Bastrop',
        'Baylor',
        'Bee',
        'Bell',
        'Bexar',
        'Blanco',
        'Borden',
        'Bosque',
        'Bowie',
        'Brazoria',
        'Brazos',
        'Brewster',
        'Briscoe',
        'Brooks',
        'Brown',
        'Burleson',
        'Burnet',
        'Caldwell',
        'Calhoun',
        'Callahan',
        'Cameron',
        'Camp',
        'Carson',
        'Cass',
        'Castro',
        'Chambers',
        'Cherokee',
        'Childress',
        'Clay',
        'Cochran',
        'Coke',
        'Coleman',
        'Collin',
        'Collingsworth',
        'Colorado',
        'Comal',
        'Comanche',
        'Concho',
        'Cooke',
        'Coryell',
        'Cottle',
        'Crane',
        'Crockett',
        'Crosby',
        'Culberson',
        'Dallam',
        'Dallas',
        'Dawson',
        'De Witt',
        'Deaf Smith',
        'Delta',
        'Denton',
        'Dickens',
        'Dimmit',
        'Donley',
        'Duval',
        'Eastland',
        'Ector',
        'Edwards',
        'El Paso',
        'Ellis',
        'Erath',
        'Falls',
        'Fannin',
        'Fayette',
        'Fisher',
        'Floyd',
        'Foard',
        'Fort Bend',
        'Franklin',
        'Freestone',
        'Frio',
        'Gaines',
        'Galveston',
        'Garza',
        'Gillespie',
        'Glasscock',
        'Goliad',
        'Gonzales',
        'Gray',
        'Grayson',
        'Gregg',
        'Grimes',
        'Guadalupe',
        'Hale',
        'Hall',
        'Hamilton',
        'Hansford',
        'Hardeman',
        'Hardin',
        'Harris',
        'Harrison',
        'Hartley',
        'Haskell',
        'Hays',
        'Hemphill',
        'Henderson',
        'Hidalgo',
        'Hill',
        'Hockley',
        'Hood',
        'Hopkins',
        'Houston',
        'Howard',
        'Hudspeth',
        'Hunt',
        'Hutchinson',
        'Irion',
        'Jack',
        'Jackson',
        'Jasper',
        'Jeff Davis',
        'Jefferson',
        'Jim Hogg',
        'Jim Wells',
        'Johnson',
        'Jones',
        'Karnes',
        'Kaufman',
        'Kendall',
        'Kenedy',
        'Kent',
        'Kerr   ',
        'Kimble',
        'King',
        'Kinney',
        'Kleberg',
        'Knox',
        'La Salle',
        'Lamar',
        'Lamb',
        'Lampasas',
        'Lavaca',
        'Lee',
        'Leon',
        'Liberty',
        'Limestone',
        'Lipscomb',
        'Live Oak',
        'Llano',
        'Loving',
        'Lubbock',
        'Lynn',
        'Madison',
        'Marion',
        'Martin',
        'Mason',
        'Matagorda',
        'Maverick',
        'McCulloch',
        'McLennan',
        'McMullen',
        'Medina',
        'Menard',
        'Midland',
        'Milam',
        'Mills',
        'Mitchell',
        'Montague',
        'Montgomery',
        'Moore',
        'Morris',
        'Motley',
        'Nacogdoches',
        'Navarro',
        'Newton',
        'Nolan',
        'Nueces',
        'Ochiltree',
        'Oldham',
        'Orange',
        'Palo Pinto',
        'Panola',
        'Parker  ',
        'Parmer',
        'Pecos',
        'Polk',
        'Potter',
        'Presidio',
        'Rains',
        'Randall',
        'Reagan',
        'Real',
        'Red River',
        'Reeves',
        'Refugio',
        'Roberts',
        'Robertson',
        'Rockwall',
        'Runnels',
        'Rusk',
        'Sabine',
        'San Augustine',
        'San Jacinto',
        'San Patricio',
        'San Saba',
        'Schleicher',
        'Scurry',
        'Shackelford',
        'Shelby',
        'Sherman',
        'Smith',
        'Somervell',
        'Starr',
        'Stephens',
        'Sterling',
        'Stonewall',
        'Sutton',
        'Swisher',
        'Tarrant',
        'Taylor',
        'Terrell',
        'Terry',
        'Throckmorton',
        'Titus',
        'Tom Green',
        'Travis',
        'Trinity',
        'Tyler',
        'Upshur',
        'Upton',
        'Uvalde',
        'Val Verde',
        'Van Zandt',
        'Victoria',
        'Walker',
        'Waller',
        'Ward',
        'Washington',
        'Webb',
        'Wharton  ',
        'Wheeler',
        'Wichita',
        'Wilbarger',
        'Willacy',
        'Williamson',
        'Wilson',
        'Winkler',
        'Wise',
        'Wood',
        'Yoakum',
        'Young',
        'Zapata',
        'Zavala'
      ]
}
counties.All = _.sortBy(_.union(counties.OK, counties.TX))

const meridians = {
  OK: [searchParameterMultiValue, 'IM', 'CM'],
  TX: null
}

const sections = {
  OK: _.range(1, 36),
  TX: _.range(1, 10)
}

const townships = {
  OK: {
    IM: initIMTownships(),
    CM: initCMTownships()
  },
  TX: {IM: [], CM: []}
}

const ranges = {
  OK: {
    IM: initIMRanges(),
    CM: initCMRanges()
  }
}

const quickAttributes = {
  apiNumber: 'API Number',
  causeNumber: 'Cause Number',
  orderNumber: 'Order Number',
  wellName: 'Well Name',
  respondent: 'Respondent'
}

const entityAttributes = {
  entity: 'All',
  operator: 'Operator',
  applicant: 'Applicant',
  lessee: 'Lessee'
}

function initIMTownships() {
  const northTownships = _.range(29).map(t => '' + (t+1) + 'N')
  const southTownships = _.range(11).map(t => '' + (t+1) + 'S')
  return _.union(northTownships, southTownships)
}

function initCMTownships() {
  const northTownships = _.range(6).map(t => '' + (t+1) + 'N')
  const southTownships = ['1S']
  return _.union(northTownships, southTownships)
}

function initIMRanges() {
  const eastRanges = _.range(27).map(t => '' + (t+1) + 'E')
  const westRanges = _.range(27).map(t => '' + (t+1) + 'W')
  return _.union(eastRanges, westRanges, ['Any'])
}

function initCMRanges() {
  const eastRanges = _.range(28).map(t => '' + (t+1) + 'E')
  eastRanges.push('Any')
  return eastRanges
}

SearchParametersService.$inject = [ 'SubscriptionService' ]

export default SearchParametersService
